jQuery(document).ready(function ($) {
  $('.FullWidthSlider').slick({
    dots: true,
    nextArrow: '<div class="SliderArrow SliderArrow--right">Suivant</div>',
    prevArrow: '<div class="SliderArrow SliderArrow--left">Précédent</div>',
    dotsClass: 'SliderDots',
  })
});

$('#slider-range').slider({
  range: true,
  min: 480,
  max: 1140,
  step: 15,
  values: [600, 720],
  slide: function (e, ui) {
    let hours1 = Math.floor(ui.values[0] / 60);
    let minutes1 = ui.values[0] - (hours1 * 60);

    if (hours1.length === 1) hours1 = '0' + hours1;
    if (minutes1.length === 1) minutes1 = '0' + minutes1;
    if (minutes1 === 0) minutes1 = '00';

    if (hours1 === 0) {
      hours1 = 12;
    }
    $('.ui-slider-handle ').first().html(hours1 + 'h');
    $('.js-hour-1').val(hours1 + 'h');
    var hours2 = Math.floor(ui.values[1] / 60);
    var minutes2 = ui.values[1] - (hours2 * 60);
    if (hours2.length === 1) hours2 = '0' + hours2;
    if (minutes2.length === 1) minutes2 = '0' + minutes2;
    if (minutes2 === 0) minutes2 = '00';
    $('.ui-slider-handle:eq( 1 )').html(hours2 + 'h');
    $('.js-hour-2').val(hours2 + 'h');
  },
});

$('.ui-slider-handle ').first().html('10h');
$('.ui-slider-handle:eq( 1 )').html('12h');

$('.TestimonySlider .container .row').slick({
  dots: true,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: '0px',
  dotsClass: 'TestimonyDots',
  nextArrow: '<div class="SliderArrow SliderArrow--right TestimonyArrowRight">Suivant</div>',
  prevArrow: '<div class="SliderArrow SliderArrow--left TestimonyArrowLeft">Précédent</div>',
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        arrows: true,
      },
    },
  ],
});
var $ServiceSlider = $('.ServiceSlider');
var $TimelineItem = $('.Timeline-Item');


$ServiceSlider.on('init', function () {
  $('.Timeline-Item[data-index="0"]').toggleClass('active');
});
$ServiceSlider.slick({
  nextArrow: '<div class="SliderArrow SliderArrow--right">Suivant</div>',
  prevArrow: '<div class="SliderArrow SliderArrow--left">Précédent</div>',
});

$ServiceSlider.on('beforeChange', function () {
  var index = $ServiceSlider.slick('slickCurrentSlide');
  $('.Timeline-Item[data-index="' + index + '"]').toggleClass('active');
});

var sliderAdaptiveHeightMobile = function () {
  $ServiceSlider.find('.slick-slide').height('0');
  $ServiceSlider.find('.slick-slide.slick-active').height('auto');
  $ServiceSlider.find('.slick-list').height('auto');
  $ServiceSlider.slick('setOption', null, null, true);
}

$ServiceSlider.on('afterChange', function () {
  var index = $ServiceSlider.slick('slickCurrentSlide');
  $(this).find('.slick-slide').height('auto');
  $('.Timeline-Item[data-index="' + index + '"]').toggleClass('active');
  if ($(window).width() <= 768) {
    sliderAdaptiveHeightMobile();
  }
});

$TimelineItem.on('click', function (e) {
  e.preventDefault();
  var indexVal = $(this).data('index');
  // console.log(indexVal);
  $ServiceSlider.slick('slickGoTo', indexVal)
  $(document).scrollTop($('#ServiceSlider').offset().top);
});

if ($(window).width() <= 768) {
  $('.ServicesTiles .row ').slick({
    dots: false,
    nextArrow: '<div class="SliderArrow SliderArrow--right">Suivant</div>',
    prevArrow: '<div class="SliderArrow SliderArrow--left">Précédent</div>',
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    centerMode: true,
    centerPadding: '0px',
  });
}
if ($(window).width() <= 1024) {
  $ServiceSlider.appendTo('#SliderModal .modal-body');
  $TimelineItem.on('click', function () {
    $('#SliderModal').modal();
  });
}



// WEBPACK FOOTER //
// ./scripts/presence/slider.js